import { render, staticRenderFns } from "./AllCompaniesList.vue?vue&type=template&id=2bd365a5"
import script from "./AllCompaniesList.vue?vue&type=script&lang=js"
export * from "./AllCompaniesList.vue?vue&type=script&lang=js"
import style0 from "./AllCompaniesList.vue?vue&type=style&index=0&id=2bd365a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports